/* src/app/warehousing/pages/warehouses/warehouses.component.scss */
/*# sourceMappingURL=warehouses.component.css.map */
